'use es6';

export const stepwiseConversionProperty = 'PERCENTILES|funnel.stepwiseConversion';
export const cumulativeConversionProperty = 'PERCENTILES|funnel.cumulativeConversion';
export const skipProperty = 'SUM|pipeline.skips';
export const totalCoversionProperty = 'PERCENTILES|pipeline.cumulativeConversion';